import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function HotPicksSection() {
  const hotComics = comics
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">评分最高的韩漫精选</p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300/60 text-foreground-400 hover:text-primary-500 hover:border-primary-300 transition-colors cursor-pointer">
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300/60 text-foreground-400 hover:text-primary-500 hover:border-primary-300 transition-colors cursor-pointer">
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              author={comic.author}
              cover={comic.cover}
              category={comic.category}
              rating={comic.rating}
              views={comic.views}
              status={comic.status}
              latestChapter={`第${comic.chapters[0]?.num}话`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}